(function(){
  /* One list drives the cards, the swatches and the count. */
  var LIVE = [
    { name:'Onyx', key:'onyx', file:'direction-onyx.html',
      tags:['Live 3D','Black','Product-led'],
      sw:['#000000','#4C7DFF','#FFB13D','#FF5CA8'] },
    { name:'Contrast', key:'contrast', file:'direction-contrast-network.html',
      tags:['Editorial','High contrast','Photographic'],
      sw:['#F4F2ED','#000000','#FF2E17'] },
    { name:'Signal', key:'signal', file:'direction-signal-network.html',
      tags:['Warm','Single hue','Rounded'],
      sw:['#F5EDE6','#0A46E0','#14110F'] },
    { name:'Sticker', key:'sticker', file:'direction-sticker-network.html',
      tags:['Playful','Family','Multi-colour'],
      sw:['#FFFBF2','#FFD23F','#1F63D6','#D62B5F'] }
  ];

  var EARLIER = [
    {name:'Blueprint',    key:'blueprint',  file:'direction-blueprint.html',  sw:['#0B2545','#FF6A13']},
    {name:'After Dark',   key:'after-dark', file:'direction-after-dark.html', sw:['#060606','#E8A317','#3DDCFF']},
    {name:'The Catalogue',key:'catalogue',  file:'direction-catalogue.html',  sw:['#F3F0E9','#111111']},
    {name:'The Grid',     key:'grid',       file:'direction-grid.html',       sw:['#FFFFFF','#111111']},
    {name:'The Shopfront',key:'shopfront',  file:'direction-shopfront.html',  sw:['#FFFFFF','#1B4DFF']}
  ];

  /* On Shopify the concepts live at /pages/<handle>, not as sibling files.
     The host page injects window.__CONCEPT_URLS; locally we use the filenames. */
  var URLS = window.__CONCEPT_URLS || {};
  var HOSTED = !!window.__CONCEPT_URLS;
  function urlFor(c){ return URLS[c.key] || c.file; }

  function el(tag, cls, txt){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(txt != null) n.textContent = txt;
    return n;
  }
  function swatches(list, into){
    var s = el('span','lfc-sw');
    list.forEach(function(c){ var i = el('i'); i.style.background = c; s.appendChild(i); });
    into.appendChild(s);
  }

  var grid = document.getElementById('lfcGrid');
  LIVE.forEach(function(c){
    var card = el('article','lfc-card');

    var thumb = el('div','lfc-thumb');
    var note  = el('div','lfc-note','Loading preview');
    var frame = document.createElement('iframe');
    frame.src = urlFor(c);
    frame.loading = 'lazy';
    frame.setAttribute('scrolling','no');
    frame.setAttribute('tabindex','-1');
    frame.title = c.name + ' preview';
    frame.addEventListener('load', function(){ thumb.classList.add('is-ready'); });
    /* If the page isn't there yet, say so rather than showing an empty box. */
    setTimeout(function(){
      if(!thumb.classList.contains('is-ready')) note.textContent = 'Preview unavailable';
    }, 8000);

    var veil = el('a','lfc-veil');
    veil.href = urlFor(c); veil.target = '_blank'; veil.rel = 'noopener';
    veil.setAttribute('aria-label','Open the ' + c.name + ' concept');
    thumb.appendChild(frame); thumb.appendChild(note); thumb.appendChild(veil);

    var body = el('div','lfc-body');
    var row  = el('div','lfc-row');
    row.appendChild(el('h2','lfc-name', c.name));
    swatches(c.sw, row);
    body.appendChild(row);

    var tags = el('div','lfc-tags');
    c.tags.forEach(function(t){ tags.appendChild(el('span', null, t)); });
    body.appendChild(tags);

    var go = el('div','lfc-go');
    var open = el('a','lfc-btn','Open concept');
    open.href = urlFor(c); open.target = '_blank'; open.rel = 'noopener';
    go.appendChild(open);
    body.appendChild(go);

    card.appendChild(thumb); card.appendChild(body);
    grid.appendChild(card);
  });

  var earlierWrap = document.getElementById('lfcEarlier');
  var earlier = EARLIER.filter(function(c){ return !HOSTED || URLS[c.key]; });
  earlier.forEach(function(c){
    var a = document.createElement('a');
    a.href = urlFor(c); a.target = '_blank'; a.rel = 'noopener';
    a.appendChild(el('b', null, c.name));
    swatches(c.sw, a);
    earlierWrap.appendChild(a);
  });
  if(!earlier.length) earlierWrap.closest('.lfc-more').style.display = 'none';

  document.getElementById('lfcCount').textContent = LIVE.length + ' concepts';
  document.getElementById('lfcStamp').textContent =
    'Longfield Media — concept previews · ' + LIVE.length + ' current' +
    (earlier.length ? ', ' + earlier.length + ' earlier' : '');

  /* Scale each 1440px-wide preview down to whatever the card is. */
  function fit(){
    document.querySelectorAll('.lfc-thumb').forEach(function(t){
      var f = t.querySelector('iframe');
      if(!f) return;
      var w = t.clientWidth, h = t.clientHeight;
      if(!w || !h) return;                    /* never divide by a zero width */
      var s = w / 1440;
      f.style.transform = 'scale(' + s + ')';
      f.style.height = Math.round(h / s) + 'px';
    });
  }
  addEventListener('resize', fit);
  fit();
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  setTimeout(fit, 300);
})();
